import React from 'react'
import {Modal, Form, Input, Button, Row, Col} from 'antd'

interface ChangePasswordModalProps {
    isVisible: boolean
    onCancel: () => void
    changePassword: (arg: string) => Promise<boolean>
}


const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({isVisible, onCancel, changePassword}) => {

    const [form] = Form.useForm()

    const handleOk = () => {
        form
            .validateFields()
            .then(values => {
                const newPassword = values["new-password"]
                changePassword(newPassword).then(res => {
                        if (res) form.resetFields()
                    }
                )
            })
            .catch(info => {
                console.error(info)
            })
    }

    return (
        <Modal
            title={"Change Password"}
            open={isVisible}
            onOk={handleOk}
            onCancel={onCancel}
            footer={[
                <Button key="back" onClick={onCancel}>
                    Cancel
                </Button>,
                <Button key="create" type="primary" onClick={handleOk}>
                    Change Password
                </Button>,
            ]}
        >
            <Form form={form}>
                <Row>
                    <Col span={16}>
                        <Form.Item
                            name="new-password"
                            rules={[{required: true, message: "Please enter your new password"}]}
                        >
                            <Input.Password placeholder="New Password"/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={16}>
                        <Form.Item
                            name="new-password-confirmation"
                            dependencies={['new-password']}
                            rules={[
                                {required: true, message: "Please confirm your new password"},
                                ({getFieldValue}) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('new-password') === value) {
                                            return Promise.resolve()
                                        }
                                        return Promise.reject(new Error('The two passwords do not match!'))
                                    },
                                }),
                            ]}
                        >
                            <Input.Password placeholder="Confirm New Password"/>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    )
}

export default ChangePasswordModal